import { ErrorUIFallback } from "../module/common/ErrorUIFallback";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";

type Props = {
  children: React.ReactNode;
};

export const ErrorBoundaryComponent = ({ children }: Props) => {
  return (
    <ErrorBoundary fallback={<ErrorUIFallback />}>{children}</ErrorBoundary>
  );
};
